import { jsx as _jsx } from "react/jsx-runtime";
export const CheckXs = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M13.6742 2.13086C14.0245 2.37064 14.0981 2.83203 13.8695 3.17383L7.36952 12.6738C7.08984 13.0664 6.56641 13.0938 6.25233 12.8105L1.75233 8.81054C1.44906 8.54117 1.40811 8.06902 1.68983 7.75195C1.97153 7.43508 2.44332 7.41666 2.74842 7.68945L6.6117 11.123L12.6312 2.32617C12.8638 1.98828 13.3226 1.8903 13.6742 2.13086Z",
            fill: color
        })
    });

//# sourceMappingURL=check-xs.js.map